<template>
    <div :class="centered ? 'mx-auto' : ''" :style="wrapperStyle">
        <div :style="lineStyle"></div>
    </div>
</template>

<script>
export default {
    name: 'SimpleDivider',

    props: {
        height: {
            type: Number,
            default: 1,
        },
        color: {
            type: String,
            default: '#cbccd0',
        },
        maxWidth: {
            type: String,
            default: '100%',
        },
        centered: {
            type: Boolean,
            default: false,
        },
    },

    computed: {
        wrapperStyle() {
            return { maxWidth: this.maxWidth };
        },
        lineStyle() {
            return {
                height: this.height + 'px',
                backgroundColor: this.color,
                width: '100%',
            };
        },
    },
};
</script>
